import { FAQS_FETCH, FAQS_FETCH_SUCCESS } from "./types";

export const faqsFetch = () => {
  return {
    type: FAQS_FETCH,
  };
};

export const faqsFetchSuccess = (payload) => {
  return {
    type: FAQS_FETCH_SUCCESS,
    payload: payload,
  };
};
